import { OnBoardingComponent } from "./on-boarding/on-boarding.component";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ChartsModule } from "ng2-charts/ng2-charts";
import { FormsModule } from "@angular/forms";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { EditorModule } from "@tinymce/tinymce-angular";
import { ImageCropperModule } from "ngx-image-cropper";

import {
  AppEditorComponent,
  AppLinearGraphComponent,
  AppTimeGraphComponent,
  AppInfoBoxComponent,
  AppTargetsComponent,
  AppAnalyticsBoxComponent,
  AppSelectComponent,
  AppTimepickerComponent,
  AppDatepickerComponent,
  AppPagedTableComponent,
  AppCropperComponent,
  AppBackComponentComponent,
  AppPreviewButtonComponent,
  AppDeleteNodeComponent,
  AppNewNodeComponent,
  AppSwitchComponent,
  AppTopSwitchComponent,
  AppModalTableAnalyticsComponent,
  AppCropperImageComponent,
  AppPieGraphComponent,
  AppAutocompleteComponent,
  AppExportBtnComponent,
  AppShareComponent,
  AppMessageModalComponent,
  AppVideoUploadComponent,
  AppProgressbarComponent,
  AppAddCommentComponent,
  AppTagsComponent,
  CurriculumComponent,
  TalentPoolCandidateCard,
} from "./index";

import { NgSelectModule } from "@ng-select/ng-select";
import { ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "../shared/shared.module";
import { RouterModule } from "@angular/router";
import {
  MatAutocompleteModule,
  MatChipsModule,
  MatFormFieldModule,
  MatIconModule,
} from "@angular/material";
import { AppYearFilterComponent } from "./app-year-filter/app-year-filter.component";
import { ScheduleInterviewComponent } from "./schedule-interview/schedule-interview.component";
import { UpdateAvailabilityComponent } from "./update-availability/update-availability.component";
import { AvaliabilityOperatorComponent } from "./avaliability-operator/avaliability-operator.component";
import { TargetingComponent } from "./targeting/targeting.component";
import { TargetingSummaryComponent } from "./targeting-summary/targeting-summary.component";
import { TargetingViewComponent } from "./targeting-view/targeting-view.component";
import { CandidateSectionComponent } from "./candidate-section/candidate-section.component";
import { JobOffersSectionComponent } from "./job-offers-section/job-offers-section.component";
import { CandidateCardComponent } from "./candidate-card/candidate-card.component";
import { UserStatusComponent } from "./user-status/user-status.component";
import { CvPreviewComponent } from "./cv-preview/cv-preview.component";
import { CandidateDetailComponent } from "./candidate-detail/candidate-detail.component";
import { CandidateCommentsComponent } from "./candidate-comments/candidate-comments.component";
import { ParticipantCardComponent } from "./participant-card/participant-card.component";
import { PdfPageComponent } from "./pdf-page/pdf-page.component";
import { CommentComponent } from "./comment/comment.component";
import { PdfViewerComponent } from "./pdf-viewer/pdf-viewer.component";
import { WatcherManagerComponent } from "./watcher-manager/watcher-manager.component";
import { NewJoinOfferButtonComponent } from "./new-join-offer-button/new-join-offer-button.component";
import { CloseJobButtonComponent } from "./close-job-button/close-job-button.component";
import { UpdateExpiryDateButtonComponent } from "./update-expiry-date-button/update-expiry-date-button.component";
import { FormlyBootstrapModule } from "@ngx-formly/bootstrap";
import { FormlyModule } from "@ngx-formly/core";
import { ColWrapperComponent } from "app/formly/components/col-wrapper";
import { FormlyFieldDate } from "app/formly/components/date";
import { FormlyFieldEditor } from "app/formly/components/editor";
import { PanelWrapperComponent } from "app/formly/components/panel-wrapper.component";
import { RowWrapperComponent } from "app/formly/components/row-wrapper";
import { FormlyFieldSubmit } from "app/formly/components/submit";
import { FormlyFieldSwitch } from "app/formly/components/switch";
import { FormlyFieldTypeahead } from "app/formly/components/typeahead";
import { PreviewJoinrsAiComponent } from "./preview-joinrs-ai/preview-joinrs-ai.component";
import { FormlyFieldUpdateOwner } from "app/formly/components/update-owner";
import { FormlyFieldUpdateExpiryDate } from "app/formly/components/update-expiry-date";
import { CandidateScoreComponent } from "./candidate-score/candidate-score.component";
import { TalentPoolCandidateDetailComponent } from './talent-pool-candidate-detail/talent-pool-candidate-detail.component';
import { TalentPoolExportBtnComponent } from './talent-pool-export-btn/talent-pool-export-btn.component';

const COMMON_COMPONENT = [
  AppEditorComponent,
  AppLinearGraphComponent,
  AppTimeGraphComponent,
  AppInfoBoxComponent,
  AppSelectComponent,
  AppTimepickerComponent,
  AppDatepickerComponent,
  AppTargetsComponent,
  AppAnalyticsBoxComponent,
  AppPagedTableComponent,
  AppCropperComponent,
  AppBackComponentComponent,
  AppPreviewButtonComponent,
  AppDeleteNodeComponent,
  AppNewNodeComponent,
  AppSwitchComponent,
  AppTopSwitchComponent,
  AppModalTableAnalyticsComponent,
  AppCropperImageComponent,
  AppPieGraphComponent,
  AppAutocompleteComponent,
  AppExportBtnComponent,
  AppShareComponent,
  AppMessageModalComponent,
  AppVideoUploadComponent,
  AppProgressbarComponent,
  AppAddCommentComponent,
  AppTagsComponent,
  AppYearFilterComponent,
  AppExportBtnComponent,
  ScheduleInterviewComponent,
  UpdateAvailabilityComponent,
  AvaliabilityOperatorComponent,
  TargetingComponent,
  TargetingSummaryComponent,
  TargetingViewComponent,
  CandidateSectionComponent,
  JobOffersSectionComponent,
  CurriculumComponent,
  CandidateCardComponent,
  UserStatusComponent,
  CvPreviewComponent,
  CandidateDetailComponent,
  CandidateCommentsComponent,
  ParticipantCardComponent,
  PdfViewerComponent,
  PdfPageComponent,
  CommentComponent,
  WatcherManagerComponent,
  NewJoinOfferButtonComponent,
  CloseJobButtonComponent,
  UpdateExpiryDateButtonComponent,
  FormlyFieldSwitch,
  FormlyFieldEditor,
  FormlyFieldTypeahead,
  FormlyFieldSubmit,
  PanelWrapperComponent,
  RowWrapperComponent,
  ColWrapperComponent,
  FormlyFieldDate,
  OnBoardingComponent,
  PreviewJoinrsAiComponent,
  FormlyFieldUpdateOwner,
  FormlyFieldUpdateExpiryDate,
  CandidateScoreComponent,
  TalentPoolCandidateCard,
  TalentPoolExportBtnComponent
];

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    RouterModule,
    CommonModule,
    ChartsModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TypeaheadModule,
    TooltipModule,
    EditorModule,
    ImageCropperModule,
    NgSelectModule,
    MatIconModule,
    MatFormFieldModule,
    MatChipsModule,
    MatAutocompleteModule,
    FormlyModule.forRoot({
      types: [
        {
          name: "date",
          component: FormlyFieldDate,
          wrappers: ["form-field"],
        },
        {
          name: "switch",
          component: FormlyFieldSwitch,
          wrappers: ["form-field"],
        },
        {
          name: "editor",
          component: FormlyFieldEditor,
          wrappers: ["form-field"],
        },
        {
          name: "submit",
          component: FormlyFieldSubmit,
          wrappers: ["form-field"],
        },
        {
          name: "typeahead",
          component: FormlyFieldTypeahead,
          wrappers: ["form-field"],
        },
        {
          name: "update-owner",
          component: FormlyFieldUpdateOwner,
          wrappers: ["form-field"],
        },
        {
          name: "update-expiry-date",
          component: FormlyFieldUpdateExpiryDate,
          wrappers: ["form-field"],
        },
      ],
      validationMessages: [
        // { name: 'Position', message: (err, field: FormlyFieldConfig) => `"${field.formControl.value}" is not a valid IP Address`},
        { name: "required", message: "This field is required" },
        { name: "Editor", message: "This field is required" },
      ],
      wrappers: [
        { name: "panel", component: PanelWrapperComponent },
        { name: "row", component: RowWrapperComponent },
        { name: "col", component: ColWrapperComponent },
      ],
    }),
    FormlyBootstrapModule,
  ],
  declarations: [...COMMON_COMPONENT, TalentPoolCandidateDetailComponent],
  exports: [...COMMON_COMPONENT],
})
export class CommonComponentModule { }
